import React, { useState } from 'react';
import { X } from 'lucide-react';
interface ArchiveQuestionModalProps {
  onClose: () => void;
  onSave: (data: {
    difficulty: 'Kolay' | 'Orta' | 'Zor';
    notes: string;
  }) => void;
  question: {
    id: number;
    content: string;
  };
}
export function ArchiveQuestionModal({
  onClose,
  onSave,
  question
}: ArchiveQuestionModalProps) {
  const [difficulty, setDifficulty] = useState<'Kolay' | 'Orta' | 'Zor'>('Orta');
  const [notes, setNotes] = useState('');
  const handleSave = () => {
    onSave({
      difficulty,
      notes
    });
  };
  return <div className="fixed inset-0 z-50 overflow-y-auto bg-black/75 flex items-center justify-center" data-id="element-160">
      <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600 w-full max-w-md mx-4" data-id="element-161">
        <div className="relative p-6 bg-black/90 rounded-xl" data-id="element-162">
          <div className="flex justify-between items-start mb-4" data-id="element-163">
            <h2 className="text-xl font-bold" data-id="element-164">Soruyu Arşive Ekle</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors" data-id="element-165">
              <X className="w-6 h-6" data-id="element-166" />
            </button>
          </div>
          <div className="space-y-4" data-id="element-167">
            {/* Question preview */}
            <div className="p-3 bg-white/5 rounded-lg" data-id="element-168">
              <p className="text-gray-300 line-clamp-2" data-id="element-169">{question.content}</p>
            </div>
            {/* Difficulty selection */}
            <div className="space-y-2" data-id="element-170">
              <label className="block text-sm font-medium text-gray-300" data-id="element-171">
                Zorluk Seviyesi
              </label>
              <div className="flex gap-3" data-id="element-172">
                <button onClick={() => setDifficulty('Kolay')} className={`flex-1 py-2 px-4 rounded-lg transition-colors ${difficulty === 'Kolay' ? 'bg-green-500/20 text-green-400 border border-green-500' : 'bg-white/5 text-gray-300 hover:bg-white/10'}`} data-id="element-173">
                  Kolay
                </button>
                <button onClick={() => setDifficulty('Orta')} className={`flex-1 py-2 px-4 rounded-lg transition-colors ${difficulty === 'Orta' ? 'bg-yellow-500/20 text-yellow-400 border border-yellow-500' : 'bg-white/5 text-gray-300 hover:bg-white/10'}`} data-id="element-174">
                  Orta
                </button>
                <button onClick={() => setDifficulty('Zor')} className={`flex-1 py-2 px-4 rounded-lg transition-colors ${difficulty === 'Zor' ? 'bg-red-500/20 text-red-400 border border-red-500' : 'bg-white/5 text-gray-300 hover:bg-white/10'}`} data-id="element-175">
                  Zor
                </button>
              </div>
            </div>
            {/* Notes */}
            <div className="space-y-2" data-id="element-176">
              <label className="block text-sm font-medium text-gray-300" data-id="element-177">
                Kişisel Not
              </label>
              <textarea value={notes} onChange={e => setNotes(e.target.value)} placeholder="Bu soruyla ilgili notlarınızı buraya ekleyin..." className="w-full bg-white/5 text-white rounded-lg px-4 py-3 min-h-[100px] focus:ring-2 ring-purple-500/20" data-id="element-178" />
            </div>
            {/* Action buttons */}
            <div className="flex gap-3 pt-2" data-id="element-179">
              <button onClick={onClose} className="flex-1 py-2 px-4 bg-white/5 text-gray-300 hover:bg-white/10 rounded-lg transition-colors" data-id="element-180">
                İptal
              </button>
              <button onClick={handleSave} className="flex-1 py-2 px-4 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-lg hover:opacity-90 transition-colors" data-id="element-181">
                Kaydet
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}